export default class ViewModel {
  constructor() {
    this.upgradedUrlFields = ['FinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters', 'MobileFinalUrls'];
  }
}
